var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-card',{attrs:{"border-variant":"danger","header":_vm.$t('Contact.header'),"header-bg-variant":"danger","header-text-variant":"white","align":"left"}},[_c('address',[_vm._v("\n      Smartdine sàrl"),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"mailto:smartdine@sylada.com"}},[_vm._v("smartdine@sylada.com")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46fd9808","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = null
// module chunks = 